import Vue from "vue";
import App from "./App.vue";
//import "./registerServiceWorker";
import store from "./store/store";
import router from "./router/router";
import vuetify from './plugins/vuetify';
import './auth';
import VueCompositionApi from '@vue/composition-api';
//import 'material-design-icons-iconfont/dist/material-design-icons.css';
//import "../node_modules/firebaseui/dist/firebaseui.css";

Vue.use(VueCompositionApi);

Vue.config.productionTip = false;

Vue.component('button-create', {
  data: function () {
    return {
      count: 0
    };
  },
  //template: '<button v-on:click="count++">You clicked me {{ count }} times.</button>'
  render: h => {
    return h('v-btn', [
      h('h1', "Hello")
    ]);
  },
});

// Vue.directive('focus-selectall', {
//   inserted: function (el) {
//     debugger;
//     el.addEventListener('focus', (event) => {
//       debugger;
//       el.select();
//     });
//   }
// });

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");